'use client';

import Controls from '@/components/common/navigation/components/controls';
import NavigationMenu from '@/components/common/navigation/navigation-menu';
import Button from '@/components/global/button';
import { useSidebar } from '@/context/sidebar-context';
import { CDN_BASE_URL } from '@/lib/constants/cdn';
import ROUTES from '@/lib/constants/routeConfig';
import { Menu } from 'lucide-react';
import { useTheme } from 'next-themes';
import Image from 'next/image';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

const CENTER_NAVIGATION_MENU = true;

export default function Navbar() {
  const { resolvedTheme } = useTheme();
  const pathname = usePathname();
  const { toggleSidebar } = useSidebar();

  if (pathname.startsWith(ROUTES.AUTH.ROOT)) {
    return null;
  }
  if (pathname.startsWith(ROUTES.POLICIES)) {
    return null;
  }

  return (
    <div className='border-gray-[#E5E7EB] fixed left-0 right-0 top-0 z-50 border-b bg-white dark:border-gray-700 dark:bg-background'>
      <div className='relative flex items-center justify-between p-2 md:px-6 md:py-4'>
        <div className='flex items-center gap-2'>
          <Button variant='ghost' size='icon' onClick={toggleSidebar}>
            <Menu className='text-[#D2D6DB]' />
          </Button>

          <Link href={ROUTES.HOME} className='flex items-center gap-2'>
            <div className='flex items-center gap-1'>
              <Image
                src={
                  resolvedTheme === 'dark'
                    ? `${CDN_BASE_URL}/JAQLNLogoLongWhite.png`
                    : `${CDN_BASE_URL}/JAQLNLogoLong.png`
                }
                alt='logo'
                width={65}
                height={65}
                style={{ width: 'auto', height: 'auto' }}
                className='hidden md:block'
              />

              <Image
                src='/images/icons/logo-icon.svg'
                alt='logo'
                width={24}
                height={24}
                style={{ width: 'auto', height: 'auto' }}
                className='md:hidden'
              />

              {/* Beta Tag */}
              <span className='rounded border border-gray-700 bg-black px-2 py-0.5 text-xs font-medium text-white'>
                Beta
              </span>
            </div>
          </Link>

          {!CENTER_NAVIGATION_MENU && <NavigationMenu />}
        </div>

        {CENTER_NAVIGATION_MENU && (
          <div className='absolute left-1/2 -translate-x-1/2 transform'>
            <NavigationMenu />
          </div>
        )}

        <Controls />
      </div>
    </div>
  );
}
